import React, { Component } from 'react';
import './app.css';

class Clock extends Component {
	constructor(props) {
		super(props);
		this.state = {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0
		}

	}

	componentWillMount() {
		this.getTimeUntil(this.props.deadLine)
	}

	componentDidMount() {
		setInterval(() => this.getTimeUntil(this.props.deadLine), 1000);
	}

	leading0(num) {
		return (num >= 0 && num < 10) ? '0' + num : num;
	}

	getTimeUntil(deadLine) {
		const time = Date.parse(deadLine) - Date.parse(new Date());
		const seconds = Math.floor((time / 1000) % 60);
		const minutes = Math.floor((time / 1000 / 60) % 60);
		const hours = Math.floor((time / 1000 / 60 / 60) % 24);
		const days = Math.floor(time / 1000 / 60 / 60 / 24);

		this.setState({ days, hours, minutes, seconds });
	}

	render() {
		return (
			<div>
				{this.props.deadLine ? (
					<div>
						<div className="Clock-days">{this.leading0(this.state.days)} Days</div>
						<div className="Clock-hours">{this.leading0(this.state.hours)} hours</div>
						<div className="Clock-minutes">{this.leading0(this.state.minutes)} minutes</div>
						<div className="Clock-seconds">{this.leading0(this.state.seconds)} seconds</div>
					</div>
				)
					: 'Please enter your wedding date'}

			</div>
		)
	}
}

export default Clock;